<template>
<div class="chapter">
<div class="inner_page">
<a id="pagexv">
<h2 class="fmtitle1">Chronology</h2>
<h3 class="sec1">War of the Austrian Succession in Northern Europe</h3>
<p class="noindent">Like most large conflicts, the War of the Austrian Succession was complex, although the central point at issue – whether a female could ever ascend the imperial throne in Vienna, or should she give way to a male candidate with a similar claim – was quite simple. The main events in the war fall into three distinct parts: those in northern Europe, those in southern Europe (mostly in Italy), and those in North America and Canada and the West and East Indies, where France and Great Britain were struggling together to establish and maintain overseas empires. As the events in northern Europe, specifically the Low Countries, Germany and Austria, have most relevance to the battle at Fontenoy in May 1745, only passing reference is made here to the other ‘theatres of war’.</p>
<p class="pagebreak">
</p><table class="table10">
<colgroup>
<col class="a20"/>
<col class="a80"/>
</colgroup>
<tbody>
<tr>
<td class="td1">1711</td>
<td class="td1">Archduke Charles of Austria becomes Emperor Charles VI on the death of his older brother Joseph I</td>
</tr>
<tr>
<td class="td1">1713</td>
<td class="td1">The Treaty of Utrecht contains the provisions of the Pragmatic Sanction to ensure that in the absence of a male heir, a daughter of Emperor Charles should inherit the title (thereby incidentally excluding the daughters of his deceased older brother).</td>
</tr>
<tr>
<td class="td1">1717</td>
<td class="td1">Birth of Arch-Duchess Maria-Theresa, oldest daughter of Charles VI.</td>
</tr>
<tr>
<td class="td1">1740</td>
<td class="td1">(October) Death of Emperor Charles VI. The Pragmatic Sanction invoked on behalf of Maria-Theresa. Simultaneous claim to the imperial title by the Elector of Bavaria.</td>
</tr>
<tr>
<td class="td1">1741</td>
<td class="td1">Active hostilities commence, and Prussia invades Silesia (1st Silesian War).</td>
</tr>
<tr>
<td class="td1">1742</td>
<td class="td1">Capture of Prague by French and Saxon troops. Elector Charles-Albert of Bavaria becomes Emperor Charles VII. The French evacuate Prague.</td>
</tr>
<tr>
<td class="td1">1743</td>
<td class="td1">French defeat at the battle of Dettingen by Anglo-Hanoverian army under King George II.</td>
</tr>
<tr>
<td class="td1">1745</td>
<td class="td1">Emperor Charles VII dies. Treaty agreed between Austria and Bavaria. Maria-Theresa’s husband, Archduke Francis-Stephen, elected as Emperor. <br/>(April) Saxe concentrates his army to invade the Austrian Netherlands. Siege of Tournai begins. Cumberland moves to lift the siege. <br/>(May) Battle of Fontenoy. Subsequent loss of many allied-held fortresses in the Austrian Netherlands. <br/>(July) Jacobite Rising in Scotland and northern England. <br/>2nd Silesian War begins. Cumberland recalled to Great Britain.</td>
</tr>
<tr>
<td class="td1"><a id="pagexvi">1746</a></td>
<td class="td1">Battle of Rocoux.</td>
</tr>
<tr>
<td class="td1">1747</td>
<td class="td1">Battle of Lauffeldt.</td>
</tr>
<tr>
<td class="td1">1748</td>
<td class="td1">October. Capture of Maastricht by Marshal Saxe. Treaty of Aix-la-Chapelle signed by belligerent parties to achieve an end to hostilities.</td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Chronology.vue?590619f4